import { T } from '@/components/i18n/message.i18n.component';
import { Template } from '@/gql/graphql';

import { ProductInfoRow } from '../product-info-modal/product-info-row.component';
import { tailoringHeadingMessages } from '../tailoring-heading.messages';

type Props = {
  context: 'pre-tailoring' | 'tailoring';
  template?: Template;
};

export const TemplateInfoModal = ({ template, context }: Props) => {
  return (
    <div className="flex flex-col gap-3">
      <ProductInfoRow
        labelTestId={`${context}-heading-product-info-modal-name-label`}
        valueTestId={`${context}-heading-product-info-modal-name-value`}
        label={<T {...tailoringHeadingMessages.productInfoModalNameLabel} />}
        value={template?.name}
      />
      <ProductInfoRow
        labelTestId={`${context}-heading-product-info-modal-description-label`}
        valueTestId={`${context}-heading-product-info-modal-description-value`}
        label={<T {...tailoringHeadingMessages.productInfoModalDescriptionLabel} />}
        value={template?.description}
      />
      {template?.basedOn && (
        <ProductInfoRow
          labelTestId={`${context}-heading-product-info-modal-basedOn-label`}
          valueTestId={`${context}-heading-product-info-modal-basedOn-value`}
          label={<T {...tailoringHeadingMessages.productInfoModalBasedOnProductLabel} />}
          value={template?.basedOn?.name}
        />
      )}
    </div>
  );
};
